import React from "react";
import { useSelector } from "react-redux";
import { useSubscription } from "../../context/SubscriptionContext";

const SubscribedBadge = ({ className = "" }) => {
  const { token } = useSelector((state) => state.user);
  // const { hasAccess, effectiveStatus } = useSubscription();
  const { subscription, hasAccess } = useSubscription();

  const status = String(
    subscription?.subscription_status || subscription?.status || "",
  )
    .trim()
    .toLowerCase();
  const isCanceledSubscription =
    status === "canceled" || status === "cancelled";
  const shouldShow =
    Boolean(token) &&
    !isCanceledSubscription &&
    (status === "trialing" || status === "active" || hasAccess);
  // effectiveStatus !== "canceled" &&
  // effectiveStatus !== "expired" &&
  // (effectiveStatus === "trialing" ||
  //   effectiveStatus === "active" ||
  //   hasAccess);

  if (!shouldShow) return null;

  return (
    <div
      className={`leaderboard-class-booking inline-flex items-center rounded-md border-[3px] border-[#0B2B66] bg-gradient-to-r from-[#ffef99] via-[#ffe066] to-[#ffd43b] px-4 py-1.5 shadow-[0_4px_0_#0B2B66] ${className}`}
      aria-label="Subscribed status"
    >
      <span className="font-extrabold text-[#0B2B66] text-xs md:text-sm uppercase tracking-[0.08em]">
        Subscribed
      </span>
    </div>
  );
};

export default SubscribedBadge;
